import { IS_GATEWAY_V2 } from "@/contract/gateway-version";
import { GATEWAY_ABI_V1 } from "./gateway-v1";
import { GATEWAY_ABI_V2 } from "./gateway-v2";

export { GATEWAY_ABI_V1 } from "./gateway-v1";
export { GATEWAY_ABI_V2 } from "./gateway-v2";

/**
 * The Gateway ABI for whichever generation this build talks to — see
 * `@/contract/gateway-version` for why that is a configured choice and not
 * something we can infer.
 *
 * TYPED AS V2, SELECTED AT RUNTIME. Call sites are written against the richer
 * V2 shape so that its extra fields typecheck; on a V1 build those fields are
 * simply absent at runtime. Every read of a V2-only field therefore has to
 * cope with `undefined` — optional chaining already gives it the right type,
 * so this is checked rather than assumed:
 *
 *   bv.gross_summ ?? bv.summ   // V1 had no referral cut, so gross == summ
 *
 * Reading a V2-only FUNCTION (oldGateway, referralPercent) on V1 reverts, so
 * those calls must be gated on `IS_GATEWAY_V2`, not merely coalesced.
 */
export const GATEWAY_ABI = (
  IS_GATEWAY_V2 ? GATEWAY_ABI_V2 : GATEWAY_ABI_V1
) as typeof GATEWAY_ABI_V2;
